import { PIPEDRIVE_SAVE_INTEGRATION_REQUEST_ERROR, PIPEDRIVE_SAVE_INTEGRATION_REQUEST_START, PIPEDRIVE_SAVE_INTEGRATION_REQUEST_SUCCESS } from '@domain/integrations/pipedrive-integration';
import { VTEX_SAVE_INTEGRATION_REQUEST_ERROR, VTEX_SAVE_INTEGRATION_REQUEST_SUCCESS, VTEX_SAVE_INTEGRATION_REQUEST_START } from '@domain/integrations/vtex-integration';
import { WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_ERROR, WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_SUCCESS, WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_START } from '@domain/integrations/woocommerce-integration';
import { LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_ERROR, LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_SUCCESS, LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_START } from '@domain/integrations/loja-integrada-integration';
import { createMiddleware } from '@shared/redux';
import {
    SEND_AUTHORIZATION_CODE_REQUEST_FAIL,
    SEND_AUTHORIZATION_CODE_REQUEST_FINISH,
    SEND_AUTHORIZATION_CODE_REQUEST_SUCCESS,
    START_INTEGRATION_FLOW,
} from '@domain/integrations/integration-strategies';
import {
    FACEBOOK_INTEGRATION_SAVE_TOKEN,
    FACEBOOK_INTEGRATION_SAVE_TOKEN_FAIL,
    FACEBOOK_INTEGRATION_SAVE_TOKEN_FINISH,
    FACEBOOK_INTEGRATION_SAVE_TOKEN_SUCCESS,
} from '@domain/integrations/facebook-integration';
import { PLATFORMS } from '@domain/platform';
import { getApiErrorKeyByException } from '@shared/api/api.utils';
import { trackOnRudderStack } from '../../../analytics.utils';

const getResponseDataErrors = action => action.payload.response.data.errors;

const getRequestedActionProviderId = action => action.requestAction.payload.providerId;

const getPayloadProviderId = action => action.payload.providerId;

export const integrationsMiddleware = createMiddleware({
    [START_INTEGRATION_FLOW]: (_, action) => {
        const providerId = getPayloadProviderId(action);
        trackOnRudderStack('integration_attempt', { platform: providerId, status: 'started' });
    },
    [SEND_AUTHORIZATION_CODE_REQUEST_SUCCESS]: (_, action) => {
        const providerId = getRequestedActionProviderId(action);
        trackOnRudderStack('integration_attempt', { platform: providerId, status: 'success' });
    },
    [SEND_AUTHORIZATION_CODE_REQUEST_FAIL]: (_, action) => {
        const providerId = getRequestedActionProviderId(action);
        const error = getResponseDataErrors(action);
        trackOnRudderStack('integration_attempt', { platform: providerId, status: 'failed', error });
    },
    [SEND_AUTHORIZATION_CODE_REQUEST_FINISH]: (_, action) => {
        const providerId = getRequestedActionProviderId(action);
        trackOnRudderStack('integration_attempt', { platform: providerId, status: 'finished' });
    },
    [FACEBOOK_INTEGRATION_SAVE_TOKEN]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.FACEBOOK_ADS.value, status: 'started' });
    },
    [FACEBOOK_INTEGRATION_SAVE_TOKEN_SUCCESS]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.FACEBOOK_ADS.value, status: 'success' });
    },
    [FACEBOOK_INTEGRATION_SAVE_TOKEN_FAIL]: (_, { payload }) => {
        const error = getApiErrorKeyByException(payload);
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.FACEBOOK_ADS.value, status: 'failed', error });
    },
    [FACEBOOK_INTEGRATION_SAVE_TOKEN_FINISH]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.FACEBOOK_ADS.value, status: 'finished' });
    },
    [VTEX_SAVE_INTEGRATION_REQUEST_START]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.VTEX.value, status: 'started' });
    },
    [VTEX_SAVE_INTEGRATION_REQUEST_SUCCESS]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.VTEX.value, status: 'success' });
    },
    [VTEX_SAVE_INTEGRATION_REQUEST_ERROR]: (_, { payload }) => {
        const error = payload.response.data.errors;
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.VTEX.value, status: 'failed', error });
    },
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_START]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.PIPEDRIVE.value, status: 'started' });
    },
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_SUCCESS]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.PIPEDRIVE.value, status: 'success' });
    },
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_ERROR]: (_, { payload }) => {
        const error = payload.response.data.errors;
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.PIPEDRIVE.value, status: 'failed', error });
    },
    [WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_START]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.WOOCOMMERCE.value, status: 'started' });
    },
    [WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_SUCCESS]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.WOOCOMMERCE.value, status: 'success' });
    },
    [WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_ERROR]: (_, { payload }) => {
        const error = payload.response.data.errors;
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.WOOCOMMERCE.value, status: 'failed', error });
    },
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_START]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.PIPEDRIVE.value, status: 'started' });
    },
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_SUCCESS]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.PIPEDRIVE.value, status: 'success' });
    },
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_ERROR]: (_, { payload }) => {
        const error = payload.response.data.errors;
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.PIPEDRIVE.value, status: 'failed', error });
    },
    [LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_START]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.LOJA_INTEGRADA.value, status: 'started' });
    },
    [LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_SUCCESS]: () => {
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.LOJA_INTEGRADA.value, status: 'success' });
    },
    [LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_ERROR]: (_, { payload }) => {
        const error = payload.response.data.errors;
        trackOnRudderStack('integration_attempt', { platform: PLATFORMS.LOJA_INTEGRADA.value, status: 'failed', error });
    },
}, { beforeChanges: true });
